import WarpElement from '@warp-ds/elements-core';
import { html, css } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import pulse from '@finn-no/pulse-sdk';

class RealEstateSearch extends WarpElement {
    static properties = {
        backgroundImageUrl: { attribute: true, type: String },
        backgroundPosition: { attribute: true, type: String },
        displayText: { attribute: true, type: String },
        placesToLive: { attribute: true, type: String },
    };

    static styles = [
        WarpElement.styles,
        css`
            *,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0;box-sizing:border-box;border-style:solid;border-width:0;border-color:var(--w-s-color-border,var(--w-s-color-border-default))}html{font-size:62.5%}body{background-color:var(--w-s-color-background,var(--w-s-color-background-default));min-height:100%;margin:0;overflow-y:scroll}body,:host{-webkit-text-size-adjust:100%;tab-size:4;-webkit-tap-highlight-color:transparent;font-family:var(--w-font-family);font-size:var(--w-font-size-m);line-height:var(--w-line-height-m);color:var(--w-s-color-text,var(--w-s-color-text-default))}hr{color:inherit;border-top-width:1px;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:700}a{cursor:pointer;color:var(--w-s-color-text-link);text-decoration:none}a:hover,a:focus,a:active{-webkit-text-decoration:var(--w-decoration-text-link);-webkit-text-decoration:var(--w-decoration-text-link);text-decoration:var(--w-decoration-text-link)}b,strong{font-weight:700}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:var(--w-s-color-text-placeholder)}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}h1{font-size:var(--w-font-size-xxl);line-height:var(--w-line-height-xxl)}h2{font-size:var(--w-font-size-xl);line-height:var(--w-line-height-xl)}h3{font-size:var(--w-font-size-l);line-height:var(--w-line-height-l)}h4{font-size:var(--w-font-size-m);line-height:var(--w-line-height-m)}h5{font-size:var(--w-font-size-s);line-height:var(--w-line-height-s)}dt,dd{margin:0 16px}h1,h2,h3,h4,h5,ul,ol,dl,p,blockquote{margin:0 0 8px}[hidden]{display:none!important}[tabindex="-1"]:focus:not(:focus-visible){outline:none}legend{float:left;width:100%;margin:0;padding:0;display:table}legend+*{clear:both}fieldset{border:0;min-width:0;margin:0;padding:.01em 0 0}body:not(:-moz-handler-blocked) fieldset{display:table-cell}.text-center{text-align:center}.bg-cover{background-size:cover}.bg-center{background-position:50%}.bg-no-repeat{background-repeat:no-repeat}.border{border-width:1px}.block{display:block}.flex{display:flex}.hidden{display:none}.underline{text-decoration-line:underline}.no-underline,.hover\\:no-underline:hover,.focus\\:no-underline:focus{text-decoration:none}.flex-col{flex-direction:column}.gap-4{gap:.4rem}.items-end{align-items:flex-end}.items-center{align-items:center}.inset-0{top:0;bottom:0;left:0;right:0}.justify-center{justify-content:center}.relative{position:relative}.static{position:static}.s-text-inverted{color:var(--w-s-color-text-inverted)}.hover\\:s-border-hover:hover{border-color:var(--w-s-color-border-hover)}.active\\:s-border-active:active{border-color:var(--w-s-color-border-active)}.shadow-s{box-shadow:var(--w-shadow-s)}.hover\\:shadow-m:hover{box-shadow:var(--w-shadow-m)}.mx-32{margin-left:3.2rem;margin-right:3.2rem}.-mt-16{margin-top:-1.6rem}.mb-0{margin-bottom:0}.font-bold{font-weight:700}.text-xs{font-size:var(--w-font-size-xs);line-height:var(--w-line-height-xs)}@media (min-width:480px){.sm\\:text-s{font-size:var(--w-font-size-s);line-height:var(--w-line-height-s)}}@media (min-width:768px){.md\\:block{display:block}.md\\:flex{display:flex}.md\\:hidden{display:none}.md\\:absolute{position:absolute}.md\\:s-text-inverted{color:var(--w-s-color-text-inverted)}};

            :host {
                display: block;
            }

            .background-container {
                height: 210px;
                background-image: linear-gradient(180deg, rgba(25, 29, 52, 0.00) 0%, rgba(25, 29, 52, 0.00) 0.01%, #191D34 100%), var(--small-background-image);

            }
            .search-heading {
                margin-bottom: 15px;
            }


            @media (min-width: 768px) {
                .background-container {
                    height: 465px;

                }
                .background-container-overlay {
                    height: 465px;
                    margin-top: 32px;
                    margin-bottom: auto;
                }
            }

            @media (min-width: 990px) and (min-height: 1360px) {
                .background-container-overlay {
                    height: 465px;
                    justify-content: center;
                    margin-top: auto;
                    margin-bottom: auto;
                }
            }

            @media (min-width: 990px ) and (min-height: 1360px) {
                .background-container {
                    height: 680px;
                }
                .search-heading {
                    margin-bottom: 40px;
                }
            }

            .display-text {
                font-size: 34px;
                line-height: 1.5;
            }

            @media (min-width: 768px) {
                .display-text {
                    font-size: 50px;
                }
            }

            @media (min-width: 990px) {
                .display-text {
                    font-size: 64px;
                }
            }

            @media (min-width: 990px) and (min-height: 1360px) {
                .display-text {
                    font-size: 96px;
                    line-height: 91px;
                }
            }


            .search-box {
                display: flex;
                flex-direction: column;
                padding: 16px 16px 32px 16px;
                gap: 16px;
            }

            @media (min-width: 768px) {
                .search-box {
                    display: flex;
                    flex-direction: column;

                    border-radius: 8px;
                    width: 50%;
                    max-width: 576px;
                    padding: 46px 40px 45px 40px;

                    color: #fff;
                    gap: 16px;
                }
            }

            @media (min-width: 990px) {
                .search-box {
                    display: flex;
                    flex-direction: column;

                    border-radius: 8px;
                    width: 50%;
                    max-width: 576px;
                    padding: 46px 40px 45px 40px;

                    color: #fff;
                    gap: 16px;
                }
            }

            .link-button {
                display: flex;
                width: 100px;
                border-radius: 4px;
                border: 1px solid #c3ccd9;
                background: white;
                padding: 10px 16px;
                justify-content: center;
                align-items: center;
                color: #3f3f46;
                gap: 8px;
            }

            .search-area {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
            }

            @media (min-width: 768px) {
                .search-area {
                    gap: 16px;
                }
            }

            .search-area > span {
                flex-grow: 3;
                flex-shrink: 1;
                flex-basis: 0;
            }

            .search-area > a.link-button {
                flex-grow: 0;
                flex-shrink: 0;
                flex-basis: 0;
            }
        `,
    ];

    render() {
        const backgroundStyles = {

            'background-position-y': this.backgroundPosition || 'center',
            '--small-background-image': `url(${this.backgroundImageUrl})`
        };

        return html`
            <div class="relative -mt-16">
                <div
                    class="background-container flex flex-col justify-center items-center bg-cover bg-center bg-no-repeat"
                    style=${styleMap(backgroundStyles)}
                >
                    <strong
                        class="md:hidden font-bold text-center display-text s-text-inverted mx-32"
                        >${this.displayText}&nbsp;</strong
                    >
                </div>
                <div
                    class="md:absolute inset-0 background-container-overlay flex flex-col items-center bg-cover bg-center bg-no-repeat"
                >
                    <strong
                        class="hidden md:flex font-bold text-center display-text s-text-inverted search-heading mx-32"
                        >${this.displayText}&nbsp;</strong
                    >
                    <div class="search-box">
                        <strong>Ikke tenk på det, på FINN har vi ${this.placesToLive} steder du kan bo</strong>
                        <div class="search-area">
                            <span><slot name="globalSearch"></slot></span>
                            <a
                                href="/map/realestate/homes"
                                class="link-button shadow-s hover:shadow-m hover:s-border-hover active:s-border-active no-underline hover:no-underline focus:no-underline"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25"
                                    height="24"
                                    viewBox="0 0 25 24"
                                    fill="none"
                                >
                                    <path
                                        d="M12.125 18.2852L8.88529 19.5811C8.64687 19.6765 8.38091 19.6765 8.1425 19.5811L1.92028 17.0922C1.54062 16.9403 1.29167 16.5726 1.29167 16.1637L1.29167 2.79002C1.29167 2.08256 2.0062 1.5988 2.66306 1.86154L8.1425 4.05332C8.38091 4.14869 8.64687 4.14869 8.88528 4.05332L15.3647 1.46154C15.6031 1.36618 15.8691 1.36618 16.1075 1.46154L22.3297 3.95043C22.7094 4.1023 22.9583 4.47001 22.9583 4.87891V9.25743"
                                        stroke="#0063FB"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        d="M8.51389 4.2019L8.51389 19.3686"
                                        stroke="#0063FB"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M15.7361 2.0354L15.7361 8.5354"
                                        stroke="#0063FB"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M22.9583 15.3963C22.9583 17.7896 18.8516 22.6185 18.625 22.6185C18.3984 22.6185 14.2917 17.7896 14.2917 15.3963C14.2917 13.0031 16.2318 11.063 18.625 11.063C21.0182 11.063 22.9583 13.0031 22.9583 15.3963Z"
                                        stroke="#0063FB"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        d="M18 16H19.5"
                                        stroke="#0063FB"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                </svg>
                                <strong class="hidden md:block">Kart</strong>
                            </a>
                        </div>

                        <p class="flex items-end text-xs sm:text-s  mb-0">...eller gjør som alle andre og se på&nbsp;
                            <a class="flex items-end gap-4 mb-0 md:s-text-inverted underline" href="/realestate/homes/search.html?property_type=11" @click=${() => pulse.trackEvent({
            type: 'Click',
            intent: 'Search',
            name: "Front search",
            object: {
                type: 'SearchItem',
                searchType: "re dummy search"
            },
            vertical: {
                name: 'realestate',
            },
        })
            }>
                                <strong>småbruk</strong>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M17 12V22H4V18.6127V12"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M17 22H22.5V4C22.5 2.89543 21.6046 2 20.5 2H19C17.8954 2 17 2.89543 17 4V9"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M13.9002 21.6125L7.10019 16.0875"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M14 22V16H7V22"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M17 7H22.5"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M17 16H22.5"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M17 19H22.5"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M2 13L10.5 7L19 13"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M9 11.9375L10.5 11L12 11.9375"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M2 6L3.5 7.0625L5 6"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M6 2L7.5 3.0625L9 2"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('realestate-search', RealEstateSearch);
